import {Injectable} from '@angular/core';
import {UsersService} from '../api/services/users.service';
import {BasicSoftphoneService as BasicSoftphoneApiService} from '../api/services/basic-softphone.service';
import {PbxService} from '../api/services/pbx.service';
import { HttpClient } from '@angular/common/http';
import {AuthService} from '../core/security/auth.service';
import {BasicSoftPhoneSummaryModel} from '../api/models/basic-soft-phone-summary-model';
import {BasicSoftPhoneChangePasswordModel, BasicSoftPhoneSaveSettingsModel} from '../api/models';

@Injectable()
export class BasicSoftPhoneService {

  constructor(private apiUserService: UsersService,
              private apiPbxService: PbxService,
              private httpClient: HttpClient,
              private authService: AuthService,
              private softphoneApiService: BasicSoftphoneApiService
  ) {

  }

  async getSoftphoneSummary(): Promise<BasicSoftPhoneSummaryModel> {

    const summary = await this.softphoneApiService.basicSoftphoneSummary()
      .toPromise();

    return summary;
  }

  async changeSoftPhonePassword(model: BasicSoftPhoneChangePasswordModel): Promise<boolean> {
    await this.softphoneApiService.basicSoftphoneChangePassword({body: model})
      .toPromise();

    return true;
  }

  async saveSoftPhoneSettings(model: BasicSoftPhoneSaveSettingsModel): Promise<boolean> {
    await this.softphoneApiService.basicSoftphoneSaveSoftPhoneSettings({body: model})
      .toPromise();

    return true;
  }
}
